import { createReducer, on } from '@ngrx/store';

import * as fromActions from './actions';

export interface AuthState {
  authenticated: boolean;
  authenticating: boolean;
  initPayloadErrored?: string;
  supportedQuickActions?: string[];
}

export const initialState: AuthState = {
  authenticated: false,
  authenticating: false,
  supportedQuickActions: [],
};

export const reducer = createReducer(
  initialState,
  on(fromActions.authenticate, (state, { supportedQuickActions: qa }) => ({
    ...state,
    authenticating: true,
    initPayloadErrored: '',
    supportedQuickActions: state.supportedQuickActions?.concat(qa ?? []),
  })),
  on(fromActions.authenticateSuccess, fromActions.stillAuthenticated, state => ({ ...state, authenticated: true })),
  on(fromActions.authenticateFailure, (state, { initPayloadErrored }) => ({ ...state, initPayloadErrored })),
  on(fromActions.authenticateSuccess, fromActions.authenticateFailure, state => ({
    ...state,
    authenticating: false,
  })),
);
